import React from "react";

const ManageDriverProfile = () => {
  return <div>ManageDriverProfile</div>;
};

export default ManageDriverProfile;
